import { useMediaQuery } from 'react-responsive';
import { BackgroundColor } from '../../app/theme/tokens/colors';
import { ReadOnlyMainHeader } from './header/header';

export const PublicLayout = (props) => {
    let style = { backgroundColor: BackgroundColor };
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 600px)' });
    if (!isTabletOrMobile) {
        style.width = '100%';
        style.minHeight = '100%';
        style.margin = 'auto auto';
    }
    return (
        <div style={style}>
            <ReadOnlyMainHeader></ReadOnlyMainHeader>
            <div>{props.outlet ? props.outlet : <></>}</div>
        </div>
    );
};
